/*
 * Saturn Squeeze — size-guide modal controller.
 * Native <dialog>: showModal() gives the UA-built focus trap + Esc-to-close +
 * inert background for free, so this is just open/close wiring + backdrop click.
 * Idempotent: guards against double-binding when the PDP re-renders (variant
 * swaps, section-rendering API).
 */
(function () {
  function init(root) {
    if (root.dataset.ssSizeguideReady === 'true') return;
    root.dataset.ssSizeguideReady = 'true';

    var trigger = root.querySelector('[data-ss-sizeguide-open]');
    var dialog = root.querySelector('dialog.ss-sizeguide__dialog');
    if (!trigger || !dialog) return;

    var closeBtn = dialog.querySelector('[data-ss-sizeguide-close]');

    trigger.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    // Click on the backdrop (outside the panel) closes the dialog.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-ss-sizeguide]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-bind after Shopify section re-renders (e.g. variant change).
  document.addEventListener('shopify:section:load', boot);
})();
